module.exports = __webpack_public_path__ + "static/07-19f27d30fd41ebbfd00e0822711194ca.jpg";